import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "image"]

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    const imageUrl = event.currentTarget.getAttribute("href")
    this.imageTarget.src = imageUrl
    this.imageTarget.alt = event.currentTarget.dataset.lightboxAlt || ""
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.closeOnEscape)
  }

  close(event) {
    if (event) event.preventDefault()

    this.modalTarget.classList.add("hidden")
    this.imageTarget.removeAttribute("src")
    this.imageTarget.alt = ""
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close(event)
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close(event)
    }
  }
}
